import React, { useState } from 'react';
import { IconButton, } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { observer } from 'mobx-react';
import { Menu } from '@jbrowse/core/ui';
const ViewMenu = observer(function ({ model, IconButtonProps, IconProps, }) {
    var _a;
    const [anchorEl, setAnchorEl] = useState();
    if (!((_a = model.menuItems()) === null || _a === void 0 ? void 0 : _a.length)) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { ...IconButtonProps, "aria-label": "more", "aria-controls": "view-menu", "aria-haspopup": "true", onClick: event => setAnchorEl(event.currentTarget), "data-testid": "view_menu_icon" },
            React.createElement(MenuIcon, { ...IconProps })),
        React.createElement(Menu, { anchorEl: anchorEl, open: Boolean(anchorEl), onMenuItemClick: (_, callback) => {
                callback();
                setAnchorEl(undefined);
            }, onClose: () => setAnchorEl(undefined), menuItems: model.menuItems() })));
});
export default ViewMenu;
